/* eslint-disable */
// jshint ignore: start
import store from '@/store';

/**
 * 관리대상 이벤트 애니메이션 효과
 * @author KangBonghun(toto1323)
 * @param  {[type]} Q [description]
 * @return {[type]}   [description]
 */
(function(Q) {
  function EventEffectSupport(graph) {
    this.nodeMap = {};
    this.graph = graph;
  }

  EventEffectSupport.prototype = {
    nodeMap: null,
    length: 0,
    graph: null,
    timer: null,
    normalColor: null,
    show: function(node) {
      this.hide(node);
      this.nodeMap[node.id] = node;
      this.length++;
      this.normalColor = store.state.common.eventlevelInfo['NM'].eventlevelColorBg || '#4db2eb';

      var ui = new CircleUI({
        draw: function (g) {
          var r = this.r || 1;
          var color = this.fillColor || Q.toColor(0x55FFAA00);
          g.globalAlpha  = this.alpha || 0;
          g.fillStyle = color;
          g.beginPath();
          g.arc(r, r, r, 0, 2 * Math.PI);
          g.fill();
        }
      });
      ui.zIndex = -1;
      ui.visible = false;

      node.addUI(ui);
      node.eventEffectUI = ui;
    },
    hide: function(node) {
      if(node.eventEffectUI) {
        node.removeUI(node.eventEffectUI);
        node.eventEffectUI = null;
      }
      this._doRemove(node.id);
    },
    _doRemove: function(id) {
      if (this.nodeMap[id]) {
        delete this.nodeMap[id];
        this.length--;
      }
    },
    stop: function() {
      cancelAnimationFrame(this.timer);
      this.timer = null;
    },
    start: function(fps) {
      if(this.timer) {
        this.stop();
      }

      if(this.graph.editable == true) {
        return;
      }

      var step = 1;
      var fpsInterval = 1000 / (fps || 60);
      var startTime = Date.now();
      var offset = 0;
      var scope = this;
      scope.timer = requestAnimationFrame(function A() {
        var now = Date.now();
        var elapsed = now - startTime;

        if (elapsed > fpsInterval) {
          startTime = now - (elapsed % fpsInterval);

          offset += 1;

          for(var id in scope.nodeMap) {
            var node = scope.graph.getElement(id);
            if(!node) {
              scope._doRemove(id);
              continue;
            }
            var ui = node.eventEffectUI;
            if(!ui) {
              scope._doRemove(id);
              continue;
            }

            // 사이즈 기준 변경 (너비와 높이 중 큰 값)
            var size = node.size.width > node.size.height ? node.size.width : node.size.height;
            var minScale = 1;
            var maxScale = size;
            var step = maxScale / 60;

            var scale = ui.data.r || minScale;
            if (scale > maxScale) {
              scale = minScale;
            }

            var alpha = 1 - (scale * (1 / maxScale));

            scale += step;
            ui.data.alpha = alpha * ui.parent.alpha;
            ui.data.r = scale;
            ui.data.width = scale * 2;
            ui.data.height = scale * 2;
            ui.data.fillColor = node.eventStatus ? node.eventStatus.eventlevelColorBg : this.normalColor;
            ui.invalidateData();
            ui.visible = true;

            node.invalidate();
          }
        }
        scope.timer = requestAnimationFrame(A);
      });
    }
  }

  function CircleUI(data){
    Q.doSuperConstructor(this, CircleUI, arguments);
  }
  CircleUI.prototype = {
      alignPosition: null,
      measure: function () {
          if(this.data){
              this.setMeasuredBounds(this.data.width, this.data.height);
          }
      },
      draw: function (g, scale, selected, selectionStyles) {
          this.data.draw(g);
      },
      doHitTest: function(x, y, tolerance){
          return false;
      }
  }
  Q.extend(CircleUI, Q.BaseUI);

  Q.EventEffectSupport = EventEffectSupport;
})(window.Q);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/eventEffectSupport.js